var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{domProps:{"innerHTML":_vm._s(_vm.data.message)},on:{"click":function($event){return _vm.goToNotification(_vm.data.slug, _vm.data.id)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }